import { 
  AppBar, 
  Container,
  MenuItem,
  Select,
  Toolbar, 
  createTheme,
  Typography, 
  ThemeProvider
} from '@material-ui/core';
import React from 'react';
import {makeStyles} from "@material-ui/core";
import {useNavigate} from "react-router-dom";
import { CryptoState } from '../CryptoContext';
import AuthModal from './Authentication/AuthModal';
import UserSidebar from './Authentication/UserSidebar';

//Styles for Cryptonary Text
const useStyles = makeStyles(() => ({
  title: {
    flex: 1,
    color: "gold",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    cursor: "pointer",
  },
}));

const Header = () => {
  //Whenever header gets called inside it class useStyles gets called.
  const classes = useStyles();
  const navigate = useNavigate();

  // Using the values of context here.
  const { currency, setCurrency , user} = CryptoState();
  const darkTheme = createTheme({
    palette: {
      primary: {
        main: "#fff",
      },
      type: "dark",
    },
  });

  return (
    <ThemeProvider theme={darkTheme}>
      <AppBar color="transparent" position="static">
        <Container>
          <Toolbar>
            <Typography
              onClick={() => navigate("/")}
              className={classes.title}
              variant="outlined"
            >
              Cryptonary
            </Typography>

            <Select
              variant="outlined"
              style={{
                width: 100,
                height: 40,
                marginLeft: 15,
              }}
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
            >
              <MenuItem value={"USD"}>USD</MenuItem>
              <MenuItem value={"INR"}>INR</MenuItem>
            </Select>
           {user ? <UserSidebar/> : <AuthModal/> } 
          </Toolbar>
        </Container>
      </AppBar>
    </ThemeProvider>
  );
};

export default Header;